import { render, staticRenderFns } from "./DetailTrackingAgree.vue?vue&type=template&id=1f57cea2"
import script from "./DetailTrackingAgree.vue?vue&type=script&lang=js"
export * from "./DetailTrackingAgree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports